import PermissionCell from "../../hooks/Cell/PermissionCell";
import Item from './Item'

const Module = (props) => {
    const cell = PermissionCell({
        permissions: props.permissions,
        permissionsRoles: props.permissionsRoles,
        setPermissionsSave: props.setPermissionsSave
    });
    return (
        <div className="divide-y divide-gray-100">
            {cell.permissions.length === 0 && (
                <div className="py-3 text-sm text-gray-500">
                    No hay permisos en este módulo.
                </div>
            )}
            {cell.permissions.map((permission) => (
                <Item
                    key={permission.Id}
                    permission={permission}
                    updateCheck={cell.updateCheck}
                    isEditor={props.isEditor}
                />
            ))}
        </div>
    );
};

export default Module;
